export enum PaymentProvider {
    OnlineBetaalplatform,
}

export namespace PaymentProvider {

    export function values() {
        return Object.keys(PaymentProvider).filter(
            (type) => isNaN(<any>type) && type !== 'values'
        );
    }
}


// WEBPACK FOOTER //
// ./~/angular2-template-loader!./src/app/company/models/payment-provider.ts